import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3>Outlet za Torami</h3>
          <Link to="/terms">Regulamin</Link>
          <Link to="/privacy">Polityka Prywatności</Link>
        </div>
        <div className="footer-section">
          <h3>Kontakt</h3>
          <p>Email: kontakt@outletzatorami.pl</p>
          <p>Tel: +48 123 456 789</p>
        </div>
      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Outlet za Torami. Wszystkie prawa zastrzeżone.</p>
      </div>
    </footer>
  );
};

export default Footer;
